import { Button } from '@components/styled/Button.styled';
import { Input } from '@components/styled/Input.styled';
import { Option } from '@components/styled/Option.styled';
import { Select } from '@components/styled/Select.styled';
import { fontButtonDefault } from '../../typography.styled';

import { TextInput } from '@components/styled/TextInput.styled';
import { Title } from '@components/styled/Title.styled';
import { Colors } from '@src/colors';
import styled from 'styled-components';
import { InputRow } from './InputRow.styled';

export const AddressSearch = styled(InputRow)`
    ${Select} {
        z-index: 999;
        margin-bottom: 16px;
    }

    ${Input},
    ${Option} {
        text-transform: capitalize;
    }

    ${Option} {
        cursor: pointer;
    }

    ${TextInput} {
        margin-bottom: 16px;
    }
`;

export const EstimatorApp = styled.div`
    margin-bottom: 50px;

    > svg {
        margin-bottom: 85px;
    }

    ${Title} {
        margin-bottom: 15px;
    }
`;

export const Container = styled.div`
    position: relative;

    padding: 50px;
    margin-bottom: 100px;

    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: 30px;

    ${Button} {
        height: 48px;
    }

    ${Button}.reset {
        position: absolute;
        top: 20px;
        right: 20px;

        height: 48px;

        label {
            ${fontButtonDefault}
            color: ${Colors.vacasaBlue}
        }
    }
`;

export const HomeDetails = styled.div`
    display: flex;
    flex-wrap: wrap;
    row-gap: 45px;
    column-gap: 45px;
    margin-top: 16px;
`;

export const Form = styled.form``;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
export const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    row-gap: 45px;
    column-gap: 45px;
`;
